<script>
import Logout from "./../Logout.svelte"
import { user } from "./../stores.js"
import PushNotification from "./PushNotification.svelte"
let drawer;

function toggle(event) {
    drawer.classList.toggle("drawer--closed");
}
</script>

<aside class="drawer drawer--closed" bind:this={drawer}>
  <div class="drawer-toggle" role="button" tabindex="0" on:click={toggle} on:keydown={(e) => e.key === 'Enter' && toggle(e)}>
    <span>&#9776;</span>
  </div>
  <div class="drawer-header">
    <h5>BALCON / <br>CHALET</h5>
  </div>
  <div class="drawer-content">
    {#if $user}
      <p>Bonjour <em>{$user.username}</em></p>
    <Logout />
    {/if}
    <PushNotification />
  </div>

  <ul class="list">
    <li class="list-item"><a href="#home" on:click={toggle} title="Home">Home</a></li>
    <li class="list-item"><a href="#camera" on:click={toggle} title="Camera">Camera</a></li>
    <li class="list-item"><a href="#sensor" on:click={toggle} title="Balcon Sensors">Balcon Sensors</a></li>
    <li class="list-item"><a href="#maple" on:click={toggle} title="Maple">Maple <small>&#127809;</small></a></li>
    <li class="list-item"><a href="#bugs" on:click={toggle} title="Bugs">Bugs</a></li>
    <li class="list-item"><a href="#forecast" on:click={toggle} title="Forecast">Forecast</a></li>
    <li class="list-item"><a href="#radar" on:click={toggle} title="Radar">Radar</a></li>
    <li class="list-item"><a href="#about" on:click={toggle} title="About">About</a></li>
  </ul>

</aside>

<style>
.drawer {
  position: fixed;
  overflow: hidden;
  height: 100%;
  top: 0;
  z-index: 3;
  background-color: #31b9a3;
  width: 55vw;
  left: 0;
  margin-left: 0;
  -webkit-transition: all .6s ease-in-out;
          transition: all .6s ease-in-out;
  overflow-y: auto;
  overflow-x: hidden;
}
.drawer.drawer--closed {
  left: -55vw;
  margin-left: 68px;
}
.drawer-toggle {
  text-align: right;
  position: absolute;
  height: 100%;
  width: 45px;
  right: 12px;
  font-size: 40px;
  cursor: pointer;
  z-index: 1;
}
.drawer-toggle span {
  width: auto;
  display: block;
  right: 0;
  position: absolute;
  margin-right: 4px;
  cursor: pointer;
  -webkit-transition: -webkit-transform .6s ease-in-out;
          transition:         transform .6s ease-in-out;
}
.drawer-toggle span:hover, .drawer-toggle:hover span {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}
.drawer  .drawer-content {
  margin: 10px 30px;
}
.drawer :global(h5) {
  margin: 10px 16px;
  padding: 0 10px;
  font-size: calc(22px + (72 - 14) * ((100vw - 300px) / (1600 - 300)));
  line-height: calc(22px + (72 - 14) * ((100vw - 300px) / (1600 - 300)));
}
.drawer-header {
  margin-top: 40px;
}
.list {
  -webkit-font-smoothing: antialiased;
  font-weight: 400;
  letter-spacing: .00937em;
  text-decoration: inherit;
  text-transform: inherit;
  margin: 0;
  padding: 8px 0;
  list-style-type: none;
}
.list-item {
  display: flex;
  position: relative;
  padding: 0 16px;
}
.list-item a {
  height: 100%;
  width: auto;
  font-decoration: none;
  align-items: center;
  padding: 0 10px;
  font-size: calc(14px + (32 - 14) * ((100vw - 300px) / (1600 - 300)));
  line-height: calc(26px + (36 - 16) * ((100vw - 300px) / (1600 - 300)));
}
.list-item a:hover {
  
}
@media only screen
and (min-device-width : 768px)
and (max-device-width : 1024px)
and (orientation : portrait) {

}
@media only screen and (max-width: 600px) {
  .drawer {
    position: fixed;
    width: 100vw;
    height: 100vh;
  }
  .drawer.drawer--closed {
    left: 0;
    margin-left: 0;
    height: 80px;
    margin-bottom: 20px;
  }
  .drawer-toggle {
    width: 100%;
    height: 65px;
    margin-top: 11px;
  }
  .drawer-header {
    margin-top: 80px;
  }
  .list-item a {
  font-size: calc(32px + (32 - 14) * ((100vw - 300px) / (1600 - 300)));
  line-height: calc(38px + (36 - 16) * ((100vw - 300px) / (1600 - 300)));
}
}
</style>